webpackJsonp([1],{

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var Component = __webpack_require__(45)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(433),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_bus_js__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_offline_plugin_runtime__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_offline_plugin_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_i18n__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_en_json__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__i18n_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_tw_json__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_tw_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__i18n_tw_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raven_js__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raven_js_plugins_vue__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_raven_js_plugins_vue__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

















// OfflinePlugin
__WEBPACK_IMPORTED_MODULE_6_offline_plugin_runtime__["install"]({
  onUpdateReady: function onUpdateReady() {
    __WEBPACK_IMPORTED_MODULE_6_offline_plugin_runtime__["applyUpdate"]();
    __WEBPACK_IMPORTED_MODULE_2__lib_bus_js__["a" /* default */].isUpdate = true;
    console.log('New Version, Ready To Update...');
  },
  onUpdated: function onUpdated() {
    console.log('Update is Completed !');
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_2__lib_bus_js__["a" /* default */].isUpdate = false;
    }, 3000);
  }
});

// Raven
if (true) {
  __WEBPACK_IMPORTED_MODULE_10_raven_js___default.a.config('https://9e8415422ae94e758e11bf598ab2d0a6@sentry.io/286495').addPlugin(__WEBPACK_IMPORTED_MODULE_11_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();
}

__WEBPACK_IMPORTED_MODULE_2__lib_bus_js__["a" /* default */].init();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// VueI18n
var locale = localStorage.lang;
var messages = {
  en: __WEBPACK_IMPORTED_MODULE_8__i18n_en_json___default.a,
  tw: __WEBPACK_IMPORTED_MODULE_9__i18n_tw_json___default.a
};
var i18n = new __WEBPACK_IMPORTED_MODULE_7_vue_i18n__["a" /* default */]({
  locale: locale,
  messages: messages
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: function data() {
    return {
      bus: __WEBPACK_IMPORTED_MODULE_2__lib_bus_js__["a" /* default */]
    };
  },

  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  i18n: i18n,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(112);




var bus = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  data: function data() {
    return {
      snackbar: {
        timeout: 1000,
        color: '',
        isOpen: false,
        msg: ''
      },
      isUpdate: false,
      isShowAboutMe: false,
      localStorageData: {}
    };
  },

  watch: {
    'localStorageData.lang': function localStorageDataLang(value) {
      localStorage.lang = value;
    },
    'localStorageData.themeColor': function localStorageDataThemeColor(value) {
      localStorage.themeColor = value;
    },
    'localStorageData.custom': function localStorageDataCustom(value) {
      localStorage.custom = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value);
    }
  },
  methods: {
    init: function init() {
      this.initLocalStorage();
      this.getLocalStorageData();
    },
    initLocalStorage: function initLocalStorage() {
      var isReset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var lang = navigator.language === 'zh-TW' ? 'tw' : 'en';
      var themeColor = 'cyan';
      var custom = {};
      if (isReset || !localStorage.lang) localStorage.lang = lang;
      if (isReset || !localStorage.themeColor) localStorage.themeColor = themeColor;
      if (isReset || !localStorage.custom) localStorage.custom = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(custom);
    },
    getLocalStorageData: function getLocalStorageData() {
      var localStorageData = {};
      localStorageData.lang = localStorage.lang;
      localStorageData.themeColor = localStorage.themeColor;
      localStorageData.custom = JSON.parse(localStorage.custom);
      this.localStorageData = localStorageData;
    },
    showErrorToast: function showErrorToast(msg) {
      var snackbar = {
        msg: msg,
        isOpen: true,
        color: 'error'
      };
      this.snackbar = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.snackbar, snackbar);
    },
    showSuccessToast: function showSuccessToast(msg) {
      var snackbar = {
        msg: msg,
        isOpen: true,
        color: 'success'
      };
      this.snackbar = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.snackbar, snackbar);
    }
  }
});

Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype, '$bus', {
  get: function get() {
    return this.$root.bus;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (bus);

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Main__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_NumberRandom__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_NumberRandom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_NumberRandom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_CustomizeList__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_CustomizeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_CustomizeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_CustomRandom__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_CustomRandom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_CustomRandom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Settings__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_Settings__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Main___default.a
  }, {
    path: '/number',
    name: 'Number',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_NumberRandom___default.a
  }, {
    path: '/custom',
    name: 'CustomizeList',
    component: __WEBPACK_IMPORTED_MODULE_4__components_pages_CustomizeList___default.a
  }, {
    path: '/custom/:name',
    name: 'Custom',
    component: __WEBPACK_IMPORTED_MODULE_5__components_pages_CustomRandom___default.a
  }, {
    path: '/settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_6__components_pages_Settings___default.a
  }]
}));

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      drawer: false,
      items: [{
        title: 'Home',
        icon: 'home',
        route: {
          name: 'Main'
        }
      }, {
        title: 'Random Number',
        icon: 'import_export',
        route: {
          name: 'Number'
        }
      }, {
        title: 'Customization List',
        icon: 'view_list',
        route: {
          name: 'CustomizeList'
        }
      }, {
        title: 'Settings',
        icon: 'settings',
        route: {
          name: 'Settings'
        }
      }],
      isUpdate: true
    };
  },

  computed: {
    themeColor: function themeColor() {
      return this.$bus.localStorageData.themeColor;
    },
    snackbar: function snackbar() {
      return this.$bus.snackbar;
    },
    title: function title() {
      var _this = this;

      var item = this.items.find(function (item) {
        return item.route.name === _this.$route.name;
      });
      return item ? item.title : this.$route.params.name;
    },
    routeName: function routeName() {
      return this.$route.name;
    },
    isCustomPage: function isCustomPage() {
      return this.routeName === 'Custom';
    },
    isMainPage: function isMainPage() {
      return this.routeName === 'Main';
    },
    isShowMenu: function isShowMenu() {
      return !this.isMainPage && !this.isCustomPage;
    }
  },
  watch: {
    '$bus.isUpdate': function $busIsUpdate(newVal, oldVal) {
      if (newVal === false && oldVal === true) location.reload();
    }
  },
  methods: {
    toggleDrawer: function toggleDrawer() {
      this.drawer = !this.drawer;
    },
    handleListClick: function handleListClick(item) {
      var name = item.route.name;
      if (name !== this.routeName) {
        this.$router.push({ name: name });
      } else {
        this.toggleDrawer();
      }
    },
    openSaveWindow: function openSaveWindow() {
      this.$bus.$emit('setOpenSaveWindow', true);
    },
    openDeleteWindow: function openDeleteWindow() {
      this.$bus.$emit('setOpenDeleteWindow', true);
    },
    goBack: function goBack() {
      this.$bus.$emit('goBack');
    },
    goSettings: function goSettings() {
      this.$router.push({ name: 'Settings' });
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  model: {
    prop: 'isOpen',
    event: 'input'
  },
  props: {
    isOpen: Boolean
  },
  computed: {
    themeColor: function themeColor() {
      return this.$bus.localStorageData.themeColor;
    }
  }
});

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NavigationDrawerWithToggle__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NavigationDrawerWithToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_NavigationDrawerWithToggle__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      items: ['default', 'default1'],
      count: 1,
      isOpen: false,
      isRepeat: false,
      isAutoClear: true,
      result: [],
      inputName: this.$route.params.name,
      isOpenSaveWindow: false,
      isOpenDeleteWindow: false,
      isGoBack: false
    };
  },

  computed: {
    title: {
      get: function get() {
        return this.$route.params.name;
      },
      set: function set(name) {
        this.$route.params.name = name;
      }
    },
    isDiff: function isDiff() {
      if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.custom).includes(this.title)) return true;
      var items = this.items,
          count = this.count,
          isRepeat = this.isRepeat,
          isAutoClear = this.isAutoClear;

      var config = {
        items: items,
        count: count,
        isRepeat: isRepeat,
        isAutoClear: isAutoClear
        /* eslint-disable */
      };return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.custom[this.title]) != __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(config);
    },

    custom: {
      get: function get() {
        return this.$bus.localStorageData.custom;
      },
      set: function set(value) {
        this.$bus.localStorageData.custom = value;
      }
    },
    themeColor: function themeColor() {
      return this.$bus.localStorageData.themeColor;
    }
  },
  watch: {
    title: function title() {
      this.init();
    },
    isOpenSaveWindow: function isOpenSaveWindow(bool) {
      if (!bool && this.isGoBack) this.$router.push({ name: 'CustomizeList' });
    }
  },
  methods: {
    init: function init() {
      if (!localStorage.custom) return;
      var config = JSON.parse(localStorage.custom)[this.title];
      if (!config) {
        this.items = ['default', 'default1'];
        this.count = 1;
        this.isRepeat = false;
        this.isAutoClear = true;
      } else {
        this.items = config.items;
        this.count = config.count;
        this.isRepeat = config.isRepeat;
        this.isAutoClear = config.isAutoClear;
      }
    },
    addItem: function addItem(index) {
      this.items.push(index);
    },
    removeItem: function removeItem(index) {
      this.items.splice(index, 1);
    },
    handleRandom: function handleRandom() {
      var _this = this;

      var isRepeat = this.isRepeat,
          count = this.count,
          isAutoClear = this.isAutoClear;

      this.result = isAutoClear ? [] : this.result;
      var items = isRepeat ? this.items : this.items.filter(function (item) {
        return !_this.result.includes(item);
      });
      if (isRepeat || items.length >= count) {
        for (var i = 0; i < count && items.length; i++) {
          var random = items[Math.floor(Math.random() * items.length)];
          this.result.unshift(random);
          if (!isRepeat) items.splice(items.indexOf(random), 1);
        }
        // this.result = result.concat(this.result)
      } else {
        this.showErrorToast('Because of no-repeat, please clear result first or set on with auto-clear-result.');
      }
      this.isOpen = !this.isOpen;
    },
    handleClearResult: function handleClearResult() {
      this.result = [];
    },
    showErrorToast: function showErrorToast(msg) {
      this.$bus.showErrorToast(msg);
    },
    showSuccessToast: function showSuccessToast(msg) {
      this.$bus.showSuccessToast(msg);
    },
    saveToLocal: function saveToLocal() {
      var custom = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.custom);
      var $router = this.$router,
          inputName = this.inputName,
          items = this.items,
          count = this.count,
          isRepeat = this.isRepeat,
          isAutoClear = this.isAutoClear;

      custom[inputName] = {
        items: items,
        count: count,
        isRepeat: isRepeat,
        isAutoClear: isAutoClear
      };
      this.custom = custom;
      this.showSuccessToast('Save Success, name is ' + inputName + '.');
      this.setOpenSaveWindow(false);
      $router.push({ name: 'CustomizeList' });
    },
    deleteToLocal: function deleteToLocal() {
      var custom = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.custom);
      var inputName = this.inputName,
          $router = this.$router;

      if (custom[inputName]) {
        delete custom[inputName];
        this.custom = custom;
        this.showSuccessToast('Delete Success, name is ' + inputName + '.');
      }
      this.setOpenDeleteWindow(false);
      $router.push({ name: 'CustomizeList' });
    },
    setOpenSaveWindow: function setOpenSaveWindow(bool) {
      this.isOpenSaveWindow = bool;
    },
    setOpenDeleteWindow: function setOpenDeleteWindow(bool) {
      this.isOpenDeleteWindow = bool;
    },
    toggleOpenSaveWindow: function toggleOpenSaveWindow() {
      this.setOpenSaveWindow(!this.isOpenSaveWindow);
    },
    toggleOpenDeleteWindow: function toggleOpenDeleteWindow() {
      this.setOpenDeleteWindow(!this.isOpenDeleteWindow);
    }
  },
  mounted: function mounted() {
    this.init();
  },
  created: function created() {
    var _this2 = this;

    this.$bus.$on('setOpenSaveWindow', function (bool) {
      return _this2.setOpenSaveWindow(bool);
    });
    this.$bus.$on('setOpenDeleteWindow', function (bool) {
      return _this2.setOpenDeleteWindow(bool);
    });
    this.$bus.$on('goBack', function () {
      if (_this2.isDiff) {
        _this2.isGoBack = true;
        _this2.setOpenSaveWindow(true);
      } else {
        _this2.$router.push({ name: 'CustomizeList' });
      }
    });
  },
  destroyed: function destroyed() {
    this.$bus.$off('setOpenSaveWindow');
    this.$bus.$off('setOpenDeleteWindow');
    this.$bus.$off('goBack');
  },

  components: {
    NavigationDrawerWithToggle: __WEBPACK_IMPORTED_MODULE_3__components_NavigationDrawerWithToggle___default.a
  }
});

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);


var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      items: []
    };
  },

  computed: {
    themeColor: function themeColor() {
      return this.$bus.localStorageData.themeColor;
    }
  },
  watch: {
    '$route.name': function $routeName() {
      _this.init();
    }
  },
  methods: {
    init: function init() {
      if (!localStorage.custom) return;
      var custom = JSON.parse(localStorage.custom);
      this.items = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(custom);
    },
    goCustomDetail: function goCustomDetail(name) {
      this.$router.push({ name: 'Custom', params: { name: name } });
    },
    createNew: function createNew() {
      var custom = localStorage.custom ? JSON.parse(localStorage.custom) : {};
      var name = 'New';
      var count = 0;
      while (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(custom).includes(name + count)) {
        count += 1;
      }
      name += count;
      this.goCustomDetail(name);
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    themeColor: function themeColor() {
      return this.$bus.localStorageData.themeColor;
    }
  }
});

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NavigationDrawerWithToggle__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NavigationDrawerWithToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_NavigationDrawerWithToggle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      min: 0,
      max: 10,
      count: 1,
      isRepeat: false,
      isAutoClear: true,
      isOpen: false,
      result: []
    };
  },

  computed: {
    items: function items() {
      var max = this.max,
          min = this.min;

      var length = max - min + 1;
      var items = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: length }, function (v, i) {
        return parseInt(min) + i;
      });
      return items;
    },
    themeColor: function themeColor() {
      return this.$bus.localStorageData.themeColor;
    }
  },
  methods: {
    handleRandom: function handleRandom() {
      var _this = this;

      var isRepeat = this.isRepeat,
          count = this.count,
          isAutoClear = this.isAutoClear;

      this.result = isAutoClear ? [] : this.result;
      var items = isRepeat ? this.items : this.items.filter(function (item) {
        return !_this.result.includes(item);
      });
      if (isRepeat || items.length >= count) {
        for (var i = 0; i < count && items.length; i++) {
          var random = items[Math.floor(Math.random() * items.length)];
          this.result.unshift(random);
          if (!isRepeat) items.splice(items.indexOf(random), 1);
        }
        // this.result = result.concat(this.result)
      } else {
        this.showErrorToast('Because of no-repeat, please clear result first or set on with auto-clear-result.');
      }
      this.isOpen = !this.isOpen;
    },
    handleClearResult: function handleClearResult() {
      this.result = [];
    },
    showErrorToast: function showErrorToast(msg) {
      this.$bus.showErrorToast(msg);
    }
  },
  components: {
    NavigationDrawerWithToggle: __WEBPACK_IMPORTED_MODULE_1__components_NavigationDrawerWithToggle___default.a
  }
});

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      themeColorArr: [{
        text: 'Blue',
        value: 'blue'
      }, {
        text: 'Cyan',
        value: 'cyan'
      }, {
        text: 'Red',
        value: 'red'
      }, {
        text: 'Pink',
        value: 'pink accent-2'
      }, {
        text: 'Grey',
        value: 'grey'
      }, {
        text: 'Orange',
        value: 'orange'
      }],
      langArr: [{
        text: 'English',
        value: 'en'
      }, {
        text: 'Chinese',
        value: 'tw'
      }]
    };
  },

  computed: {
    themeColor: {
      get: function get() {
        return this.$bus.localStorageData.themeColor;
      },
      set: function set(value) {
        this.$bus.localStorageData.themeColor = value;
      }
    },
    lang: {
      get: function get() {
        return this.$bus.localStorageData.lang;
      },
      set: function set(value) {
        this.$bus.localStorageData.lang = value;
        this.$i18n.locale = value;
      }
    },
    themeColorArrTrans: function themeColorArrTrans() {
      return this.transOptions(this.themeColorArr);
    },
    langArrTrans: function langArrTrans() {
      return this.transOptions(this.langArr);
    }
  },
  methods: {
    transOptions: function transOptions(options) {
      var _this = this;

      return options.map(function (option) {
        var opt = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, option);
        opt.text = _this.$t(opt.text);
        return opt;
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 405:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 410:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dice-clear.c34b5a2.png";

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(45)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(432),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(411)
}
var Component = __webpack_require__(45)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(438),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(408)
}
var Component = __webpack_require__(45)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(435),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-99df50f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(410)
}
var Component = __webpack_require__(45)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(437),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d2f68bba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(407)
}
var Component = __webpack_require__(45)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(434),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8588fb54",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(409)
}
var Component = __webpack_require__(45)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(436),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bea09ae6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 432:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item, i) {
    return _c('v-list-tile', {
      key: i,
      attrs: {
        "value": "true",
        "exact": ""
      },
      on: {
        "click": function($event) {
          _vm.handleListClick(item)
        }
      }
    }, [_c('v-list-tile', [_c('v-icon', {
      attrs: {
        "light": ""
      },
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(_vm.$t(item.title))
      }
    })], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "fixed": "",
      "app": "",
      "color": _vm.themeColor
    }
  }, [(_vm.isShowMenu) ? _c('v-toolbar-side-icon', {
    staticClass: "white--text",
    attrs: {
      "light": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDrawer($event)
      }
    }
  }) : (!_vm.isMainPage) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("home")]), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "white--text",
    domProps: {
      "textContent": _vm._s(_vm.$t(_vm.title))
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "close-on-click": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [(_vm.isCustomPage) ? [_c('v-list-tile', {
    on: {
      "click": _vm.openSaveWindow
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("save")])], 1), _vm._v(" "), _c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.$t('Save'))
    }
  })], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.openDeleteWindow
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.$t('Delete'))
    }
  })], 1)] : [(_vm.routeName != 'Settings') ? _c('v-list-tile', {
    on: {
      "click": _vm.goSettings
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.$t('Settings'))
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.$bus.isShowAboutMe = true
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("info")])], 1), _vm._v(" "), _c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.$t('About Me'))
    }
  })], 1)]], 2)], 1)], 1), _vm._v(" "), _c('v-content', [_c('router-view'), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "color": _vm.snackbar.color
    },
    model: {
      value: (_vm.snackbar.isOpen),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "isOpen", $$v)
      },
      expression: "snackbar.isOpen"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbar.msg) + "\n    ")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.$bus.isUpdate),
      callback: function($$v) {
        _vm.$set(_vm.$bus, "isUpdate", $$v)
      },
      expression: "$bus.isUpdate"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline justify-center"
  }, [_vm._v("\n          Updating\n        ")]), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    staticClass: "text-xs-center text-md-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7,
      "color": _vm.themeColor
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: (_vm.$bus.isShowAboutMe),
      callback: function($$v) {
        _vm.$set(_vm.$bus, "isShowAboutMe", $$v)
      },
      expression: "$bus.isShowAboutMe"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline justify-center"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('About Me')) + "\n        ")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v(_vm._s(_vm.$t('Thank You For Using This. Any Fallback Is Welcome 😊')))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://github.com/roysung",
      "target": "block"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "dark": "",
      "color": _vm.themeColor
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("fa-github")]), _vm._v("\n              RoySung\n            ")], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "navigation-drawer-with-toggle",
    attrs: {
      "temporary": "",
      "fixed": "",
      "right": "",
      "value": _vm.isOpen
    },
    on: {
      "input": function (value) { return _vm.$emit('input', value); }
    }
  }, [_c('button', {
    staticClass: "toggle-button lighten-3",
    class: _vm.themeColor,
    on: {
      "click": function($event) {
        _vm.$emit('input', !_vm.isOpen)
      }
    }
  }, [(_vm.isOpen) ? _c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("keyboard_arrow_right")]) : _c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "number-random"
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-flex', {
    staticClass: "input-min-wrap",
    attrs: {
      "row": "",
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "min",
      "type": "number",
      "label": _vm.$t('Minimum'),
      "prepend-icon": "keyboard_arrow_up"
    },
    model: {
      value: (_vm.min),
      callback: function($$v) {
        _vm.min = $$v
      },
      expression: "min"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "input-max-wrap",
    attrs: {
      "row": "",
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "max",
      "type": "number",
      "label": _vm.$t('Maximum'),
      "prepend-icon": "keyboard_arrow_down"
    },
    model: {
      value: (_vm.max),
      callback: function($$v) {
        _vm.max = $$v
      },
      expression: "max"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "input-count-wrap",
    attrs: {
      "row": "",
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "count",
      "type": "number",
      "label": _vm.$t('Count'),
      "prepend-icon": "format_list_numbered"
    },
    model: {
      value: (_vm.count),
      callback: function($$v) {
        _vm.count = $$v
      },
      expression: "count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "input-options-wrap",
    attrs: {
      "row": "",
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.$t('Is Repeat'),
      "value": "isRepeat"
    },
    model: {
      value: (_vm.isRepeat),
      callback: function($$v) {
        _vm.isRepeat = $$v
      },
      expression: "isRepeat"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": _vm.$t('Automatically Clear The Last Result'),
      "value": _vm.isAutoClear
    },
    model: {
      value: (_vm.isAutoClear),
      callback: function($$v) {
        _vm.isAutoClear = $$v
      },
      expression: "isAutoClear"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "input-button-wrap",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": _vm.themeColor,
      "dark": ""
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('Randomize'))
    },
    on: {
      "click": _vm.handleRandom
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('navigation-drawer-with-toggle', {
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  }, [_c('v-list', [_vm._l((_vm.result), function(item, index) {
    return [_c('v-list-tile', {
      key: 'list-item-' + index,
      class: {
        gray: index > _vm.count - 1
      },
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item)
      }
    })], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: 'list-divider-' + index
    })]
  }), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": _vm.themeColor,
      "dark": ""
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('Clear'))
    },
    on: {
      "click": _vm.handleClearResult
    }
  })], 1)], 1)], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "customize-list"
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-list', [_vm._l((_vm.items), function(name, index) {
    return _c('v-list-tile', {
      key: index,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          _vm.goCustomDetail(name)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "white--text",
      class: _vm.themeColor
    }, [_vm._v("assignment")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(name))])], 1)
  }), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": _vm.themeColor,
      "dark": ""
    },
    on: {
      "click": _vm.createNew
    }
  }, [_c('v-icon', {
    staticClass: "white--text",
    class: _vm.themeColor
  }, [_vm._v("add")]), _vm._v("\n            " + _vm._s(_vm.$t('New')) + "\n          ")], 1)], 1)], 1)], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "settings"
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('Theme Color'),
      "items": _vm.themeColorArrTrans
    },
    model: {
      value: (_vm.themeColor),
      callback: function($$v) {
        _vm.themeColor = $$v
      },
      expression: "themeColor"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('Language'),
      "items": _vm.langArrTrans
    },
    model: {
      value: (_vm.lang),
      callback: function($$v) {
        _vm.lang = $$v
      },
      expression: "lang"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', [_c('div', {
    staticClass: "logo-wrap"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('img', {
    class: _vm.themeColor,
    attrs: {
      "src": __webpack_require__(424),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "large": "",
      "dark": "",
      "color": _vm.themeColor
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Number'
        })
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("import_export")]), _vm._v("\n            " + _vm._s(_vm.$t('Random Number')) + "\n          ")], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "large": "",
      "dark": "",
      "color": _vm.themeColor
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'CustomizeList'
        })
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("view_list")]), _vm._v("\n            " + _vm._s(_vm.$t('Random Custom')) + "\n          ")], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 438:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "custom-random"
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": ""
    }
  }, [_c('v-list', [_vm._l((_vm.items), function(item, index) {
    return [_c('v-list-tile', {
      key: 'item-item-' + index,
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-content', [_c('v-text-field', {
      attrs: {
        "name": 'item-input-' + index,
        "label": index.toString(),
        "value": item,
        "autofocus": index + 1 == _vm.items.length
      },
      model: {
        value: (_vm.items[index]),
        callback: function($$v) {
          _vm.$set(_vm.items, index, $$v)
        },
        expression: "items[index]"
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "dark": "",
        "small": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          _vm.removeItem(index)
        }
      }
    }, [_c('v-icon', [_vm._v("remove")])], 1)], 1)], 1)]
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-btn', {
    attrs: {
      "block": "",
      "outline": "",
      "color": _vm.themeColor
    },
    on: {
      "click": function($event) {
        _vm.addItem(_vm.items.length)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-text-field', {
    attrs: {
      "name": "count",
      "type": "number",
      "label": _vm.$t('Count')
    },
    model: {
      value: (_vm.count),
      callback: function($$v) {
        _vm.count = $$v
      },
      expression: "count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', {
    staticClass: "options-wrap"
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.$t('Is Repeat'),
      "value": _vm.isRepeat
    },
    model: {
      value: (_vm.isRepeat),
      callback: function($$v) {
        _vm.isRepeat = $$v
      },
      expression: "isRepeat"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": _vm.$t('Automatically Clear The Last Result'),
      "value": _vm.isAutoClear
    },
    model: {
      value: (_vm.isAutoClear),
      callback: function($$v) {
        _vm.isAutoClear = $$v
      },
      expression: "isAutoClear"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-btn', {
    attrs: {
      "block": "",
      "dark": "",
      "color": _vm.themeColor
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('Randomize'))
    },
    on: {
      "click": _vm.handleRandom
    }
  })], 1)], 1)], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('navigation-drawer-with-toggle', {
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  }, [_c('v-list', [_vm._l((_vm.result), function(item, index) {
    return [_c('v-list-tile', {
      key: 'list-item-' + index,
      class: {
        gray: index > _vm.count - 1
      },
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item)
      }
    })], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: 'list-divider-' + index
    })]
  }), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": _vm.themeColor,
      "dark": ""
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('Clear'))
    },
    on: {
      "click": _vm.handleClearResult
    }
  })], 1)], 1)], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "value": _vm.isOpenSaveWindow,
      "max-width": "290"
    },
    on: {
      "input": _vm.toggleOpenSaveWindow
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline",
    domProps: {
      "textContent": _vm._s(_vm.$t('Save'))
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "autofocus": "",
      "label": _vm.$t('Item Name')
    },
    model: {
      value: (_vm.inputName),
      callback: function($$v) {
        _vm.inputName = $$v
      },
      expression: "inputName"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('Cancel'))
    },
    on: {
      "click": function($event) {
        _vm.setOpenSaveWindow(false)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": _vm.themeColor
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('Save'))
    },
    on: {
      "click": _vm.saveToLocal
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "value": _vm.isOpenDeleteWindow,
      "max-width": "290"
    },
    on: {
      "input": _vm.toggleOpenDeleteWindow
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline",
    domProps: {
      "textContent": _vm._s(_vm.$t('Delete'))
    }
  }), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('Are you sure to delete it ?')) + "\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": _vm.themeColor
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('Cancel'))
    },
    on: {
      "click": function($event) {
        _vm.setOpenDeleteWindow(false)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('Delete'))
    },
    on: {
      "click": _vm.deleteToLocal
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 442:
/***/ (function(module, exports) {

module.exports = {"Home":"Home","Random Number":"Random Number","Random Custom":"Random Custom","Customization List":"Customization List","Settings":"Settings","About Me":"About Me","Minimum":"Minimum","Maximum":"Maximum","Count":"Count","Is Repeat":"Repeat","Automatically Clear The Last Result":"Automatically Clear The Last Result","Randomize":"Randomize","Clear":"Clear","Save":"Save","Item Name":"Item Name","Delete":"Delete","Are you sure to delete it ?":"Are you sure to delete it ?","Cancel":"Cancel","New":"New","Language":"Language","Theme Color":"Theme Color","English":"English","Chinese":"Chinese","Blue":"Blue","Cyan":"Cyan","Red":"Red","Pink":"Pink","Grey":"Grey","Orange":"Orange","Thank You For Using This. Any Fallback Is Welcome 😊":"Thank You For Using This. Any Fallback Is Welcome 😊"}

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

module.exports = {"Home":"首頁","Random Number":"號碼亂數","Random Custom":"自訂隨機亂數","Customization List":"自訂隨機亂數 - 列表","Settings":"設定","About Me":"關於作者","Minimum":"最小值","Maximum":"最大值","Count":"數量","Is Repeat":"是否重複","Automatically Clear The Last Result":"自動清除上次結果","Randomize":"隨機亂數","Clear":"清除","Save":"儲存","Item Name":"項目名字","Delete":"刪除","Are you sure to delete it ?":"確定要刪除嗎 ?","Cancel":"取消","New":"新增","Language":"語言","Theme Color":"主題顏色","English":"英文","Chinese":"中文","Blue":"藍色","Cyan":"青色","Red":"紅色","Pink":"粉紅色","Grey":"灰色","Orange":"橘色","Thank You For Using This. Any Fallback Is Welcome 😊":"謝謝使用, 歡迎任何意見及回饋 😊"}

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(161);
module.exports = __webpack_require__(160);


/***/ })

},[444]);


// WEBPACK FOOTER //
// static/js/app.ef9ad9444bb7d969ff91.js